import { render } from "./tab.vue?vue&type=template&id=3ca73920&scoped=true"
import script from "./tab.vue?vue&type=script&lang=js"
export * from "./tab.vue?vue&type=script&lang=js"

import "./tab.vue?vue&type=style&index=0&id=3ca73920&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca73920"]])

export default __exports__